import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import API_URL from "../../src/Config";
import { useParams } from "react-router-dom";
import "./PrVendorDetails.css";
import Select from "react-select"; // Import react-select
import { MdAttachFile } from "react-icons/md";
import { IoCloseOutline } from "react-icons/io5";
import { FiUpload } from "react-icons/fi";
import { MdDeleteOutline } from "react-icons/md";

function ConfirmPRRequest() {
  const { pr_id } = useParams();
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [isDeletePopup, setIsDeletePopup] = useState(false);
  const [severity, setSeverity] = useState("success");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [loading, setLoading] = useState(true);
  const [emails, setEmails] = useState([]);
  const [email, setEmail] = useState([]);
  const [selectedEmail, setSelectedEmail] = useState(null);
  const [selectedEmails, setSelectedEmails] = useState(null);
  const [vendorOptions, setVendorOptions] = useState([]);
  const [selectedVendor, setSelectedVendor] = useState(null);
  const [emailTemplates, setEmailTemplates] = useState([]);
  const [prRequestHistory, setPRRequestHistory] = useState([]);
  const [emailHistoryId, setEmailHistoryId] = useState(null);

  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isPopupOpens, setIsPopupOpens] = useState(false);
  const buttonRef = useRef(null);
  const popupRef = useRef(null);
  const fileInputRef = useRef(null);
  const containerRef = useRef(null);
  const [selectedRowIndex, setSelectedRowIndex] = useState(null);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [attachmentFile, setAttachmentFile] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");
  const [file, setFile] = useState(null);
  const [validationError, setValidationError] = useState("");

  const [remarks, setRemarks] = useState("");
  const [emailData, setEmailData] = useState({
    to_email: "",
    cc_email: "",
    subject: "",
    body: "",
    dailyId: "",
  });

  // Approved States
  const [approvedFiles, setApprovedFiles] = useState([]);
  const [approvedPopupOpen, setApprovedPopupOpen] = useState(false);

  // Remarks States
  const [remarkFiles, setRemarkFiles] = useState([]);
  const [remarkPopupOpen, setRemarkPopupOpen] = useState(false);

  // File Refs
  const approvedFileRef = useRef(null);
  const approvedBtnRef = useRef(null);
  const approvedPopupRef = useRef(null);

  const remarkFileRef = useRef(null);
  const remarkBtnRef = useRef(null);
  const remarkPopupRef = useRef(null);

  const [openEmailPopupIndex, setOpenEmailPopupIndex] = useState(null);
  const [openRemarkPopupIndex, setOpenRemarkPopupIndex] = useState(null);

  const handleEmailClick = (index) => {
    setOpenEmailPopupIndex(openEmailPopupIndex === index ? null : index);
  };

  const handleRemarkClick = (index) => {
    setOpenRemarkPopupIndex(openRemarkPopupIndex === index ? null : index);
  };

  const handleCloseEmail = () => setOpenEmailPopupIndex(null);
  const handleCloseRemark = () => setOpenRemarkPopupIndex(null);

  const handleApprovedUploadClick = () => approvedFileRef.current.click();

  const handleApprovedFileChange = (e) => {
    setApprovedFiles([...approvedFiles, ...Array.from(e.target.files)]);
  };

  const handleApprovedPopupIconClick = () => setApprovedPopupOpen(true);

  const handleApprovedPopupClose = () => setApprovedPopupOpen(false);

  const handleApprovedDelete = (index) => {
    const updated = [...approvedFiles];
    updated.splice(index, 1);
    setApprovedFiles(updated);
  };

  const handleRemarkUploadClick = () => remarkFileRef.current.click();

  const handleRemarkFileChange = (e) => {
    setRemarkFiles([...remarkFiles, ...Array.from(e.target.files)]);
  };

  const handleRemarkPopupIconClick = () => setRemarkPopupOpen(true);

  const handleRemarkPopupClose = () => setRemarkPopupOpen(false);

  const handleRemarkDelete = (index) => {
    const updated = [...remarkFiles];
    updated.splice(index, 1);
    setRemarkFiles(updated);
  };

  const handleUploadButtonClick = () => {
    // Ensure the ref is not null before triggering the click
    if (fileInputRef.current) {
      fileInputRef.current.click();
    } else {
      console.error("File input ref is null");
    }
  };

  const handleFileInputChange = (e) => {
    const files = e.target.files;
    const newFileDetails = Array.from(files).map((file) => ({
      name: file.name,
      size: file.size,
    }));

    setSelectedFiles([...selectedFiles, ...newFileDetails]);

    // Set the actual file objects in the state for FormData
    setAttachmentFile((prevFiles) => [
      ...(prevFiles || []),
      ...Array.from(files),
    ]);
  };

  const handleDeleteFile = (indexToDelete) => {
    // Filter out the file at the given index and assign to updatedFiles
    const updatedFiles = selectedFiles.filter(
      (_, index) => index !== indexToDelete
    );

    // Update the state with filtered files
    setSelectedFiles(updatedFiles);

    // Close the popup if no files are left
    if (updatedFiles.length === 0) {
      handleCloseAttachment(); // Close the popup if no files remain
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEmailData((prevData) => ({
      ...prevData,
      [name]: value, // Dynamically update the correct field
    }));
  };

  const handleEmail = (selectedOption) => {
    setSelectedEmails(selectedOption);
  };

  const handleEmailChange = (selectedOption) => {
    setSelectedEmail(selectedOption); // Update the selected email in state

    // Find the selected template data from the response
    const selectedTemplate = emailTemplates.find(
      (template) => template.id === selectedOption.value
    );

    if (selectedTemplate) {
      setEmailData({
        ...emailData,
        to_email: selectedTemplate.to_emails || "", // Populate To email
        subject: selectedTemplate.subject || "", // Populate Subject
        body: selectedTemplate.body || "", // Populate Body
      });
    }
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };
  const fetchPRRequestHistory = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${API_URL}/api/pr_vendor/get_email_history/${pr_id}`,
        {
          headers: { Authorization: localStorage.getItem("authKey") },
        }
      );
      setPRRequestHistory(response.data.items);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching vendor pr request history:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPRRequestHistory();
  }, [pr_id]);

  const fetchEmail = async () => {
    try {
      const authKey = localStorage.getItem("authKey");
      const apiUrl = `${API_URL}/api/get_email_configs`;
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: authKey,
        },
      });

      if (response.ok) {
        const data = await response.json();
        const options = data.configs.map((email) => {
          const label =
            email.is_default === 1 ? `${email.email} (default)` : email.email;
          return {
            label: label, // Append (default) to the email if it is the default
            value: email.id,
          };
        });

        setEmail(options);
      } else {
        console.error("Failed to fetch email configs");
      }
    } catch (error) {
      console.error("An error occurred while fetching email configs:", error);
    }
  };

  useEffect(() => {
    fetchEmail();
  }, []);

  const fetchEmails = async () => {
    try {
      const authKey = localStorage.getItem("authKey");
      const apiUrl = `${API_URL}/api/get_email_templates`;
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: authKey,
        },
      });

      if (response.ok) {
        const data = await response.json();

        setEmailTemplates(data.templates); // Store the raw templates

        const options = data.templates.map((email) => {
          const label = email.temp_name || "No Template Name"; // Use temp_name or fallback
          return {
            label: label,
            value: email.id,
          };
        });

        setEmails(options); // Update state with formatted options
      } else {
        console.error("Failed to fetch email templates");
      }
    } catch (error) {
      console.error("An error occurred while fetching email templates:", error);
    }
  };

  useEffect(() => {
    fetchEmails();
  }, []);

  // const handleSaveClick = async () => {
  //   try {
  //     setIsLoading(true);
  //     const authKey = localStorage.getItem("authKey");
  //     // Create FormData for multipart request
  //     const formData = new FormData();

  //     // Append basic fields
  //     formData.append("config_id", selectedEmails.value);
  //     formData.append("pr_request_id", pr_id);
  //     formData.append("subject", emailData.subject);
  //     formData.append("body", emailData.body);

  //     // Convert to_email array to JSON string and append
  //     const toEmailArray = emailData.to_email
  //       ? emailData.to_email.split(",").map((email) => email.trim())
  //       : [];
  //     formData.append("to_email", JSON.stringify(toEmailArray));

  //     // Append attachments as a list
  //     if (Array.isArray(attachmentFile) && attachmentFile.length > 0) {
  //       attachmentFile.forEach((file, index) => {
  //         formData.append(`attachments[]`, file, file.name); // Using `attachments[]` to ensure it is treated as a list
  //       });
  //     }

  //     const response = await axios.post(
  //       `${API_URL}/api/purchase_request/customer/send_email`,
  //       formData,
  //       {
  //         headers: {
  //           "Content-Type": "multipart/form-data",
  //           Authorization: authKey,
  //         },
  //       }
  //     );

  //     if (response.status === 200) {
  //       setSnackbarMessage(response.data.message || "Email sent successfully");
  //       setSeverity("success");
  //       setSnackbarOpen(true);
  //       await fetchPRRequestHistory();
  //       setSelectedEmail("");
  //       setSelectedEmails("");
  //       setSelectedVendor("");
  //       setEmailTemplates("");
  //       setEmailData({ to_email: "", subject: "", body: "", dailyId: "" });
  //     } else {
  //       throw new Error(response.data.message || "Failed to send email");
  //     }
  //   } catch (error) {
  //     console.error("Error sending email:", error);
  //     setSnackbarMessage("Error sending email");
  //     setSeverity("error");
  //     setSnackbarOpen(true);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  const handleSaveClick = async () => {
    try {
      setIsLoading(true);
      const authKey = localStorage.getItem("authKey");

      // Create FormData for multipart request
      const formData = new FormData();

      // Append basic fields
      formData.append("config_id", selectedEmails.value);
      formData.append("pr_request_id", pr_id);
      formData.append("subject", emailData.subject);
      formData.append("body", emailData.body);

      // Convert to_email array to JSON string and append
      const toEmailArray = emailData.to_email
        ? emailData.to_email.split(",").map((email) => email.trim())
        : [];
      formData.append("to_email", toEmailArray.join(",")); // Send as comma-separated string

      const toCCEmailArray = emailData.cc_email
        ? emailData.cc_email.split(",").map((email) => email.trim())
        : [];
      formData.append("cc_email", toCCEmailArray.join(",")); // Send as comma-separated string

      // Append attachments correctly as expected by the backend
      if (Array.isArray(attachmentFile) && attachmentFile.length > 0) {
        attachmentFile.forEach((file) => {
          formData.append("attachments", file, file.name); // Use "attachments" without []
        });
      }

      const response = await axios.post(
        `${API_URL}/api/purchase_request/customer/send_email`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: authKey,
          },
        }
      );

      if (response.status === 200) {
        setSnackbarMessage(response.data.message || "Email sent successfully");
        setSeverity("success");
        setSnackbarOpen(true);
        await fetchPRRequestHistory();
        setSelectedEmail("");
        setSelectedEmails("");
        setSelectedVendor("");
        setEmailTemplates("");
        setSelectedFiles("");
        setEmailData({
          to_email: "",
          subject: "",
          body: "",
          dailyId: "",
          cc_email: "",
        });
      } else {
        throw new Error(response.data.message || "Failed to send email");
      }
    } catch (error) {
      console.error("Error sending email:", error);
      setSnackbarMessage("Error sending email");
      setSeverity("error");
      setSnackbarOpen(true);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchPRVendorsData = async () => {
    try {
      const authKey = localStorage.getItem("authKey");

      const response = await fetch(`${API_URL}/api/get_pr_vendors/${pr_id}`, {
        method: "GET",
        headers: {
          Authorization: authKey,
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const responseData = await response.json(); // ✅ Correct JSON parsing
      const vendors = responseData.pr_vendors || []; // ✅ Ensure pr_vendors exists
console.log("responseData", responseData)

      const options = vendors.map((vendor) => {
        const fileName =
          vendor.attachments?.length > 0
            ? vendor.attachments[0].filename
            : "No File";

        return {
          value: vendor.id,
          label: `${vendor.vendor_name} - ${fileName}`,
        };
      });

      setVendorOptions(options);
    } catch (error) {
      console.error("Error fetching vendors:", error);
    }
  };

  useEffect(() => {
    fetchPRVendorsData();
  }, [pr_id]);

  const handleIconClick = (index) => {
    // Toggle the popup open/close based on the current state
    setIsPopupOpen((prev) => (prev === index ? null : index));

    setSelectedRowIndex(false); // Reset the selected row
  };

  const handleIconClicks = (index) => {
    // Toggle the popup open/close based on the current state
    setIsPopupOpens((prev) => (prev === index ? null : index));

    setSelectedRowIndex(false); // Reset the selected row
  };

  const handleCloseAttachments = () => {
    setIsPopupOpens(false);
  };

  const handleCloseAttachment = () => {
    setIsPopupOpen(false);
  };

  const handleViewAttachment = (attachment) => {
    window.open(
      `${API_URL}/api/view_pr_attachment/${attachment.file_id}/${attachment.file_type}`,
      "_blank"
    );
  };

  const handleAction = (id) => {
    setEmailHistoryId(id); // Save the clicked ID for use in submission
    setShowPopup(true);
  };

  const handleSubmit = () => {
    if (!selectedOption) {
      setSnackbarMessage("Please select either Approve or Remarks.");
      setSeverity("error");
      setSnackbarOpen(true);
      return;
    }

    if (selectedOption === "remarks") {
      if (remarks.trim() === "") {
        setSnackbarMessage("Please enter remarks from the customer.");
        setSeverity("error");
        setSnackbarOpen(true);
        return;
      }
    }

    // Clear any previous error
    setSnackbarMessage("");
    setSnackbarOpen(false);

    setIsDeletePopup(true); // Open the confirmation popup
  };

  //  const emailHistoryId = prRequestHistory?.[0]?.id || null;

  const handleFinalSubmit = async () => {
    const formData = new FormData();
    formData.append("email_history_id", emailHistoryId); // make sure this state holds correct ID

    try {
      const authKey = localStorage.getItem("authKey");
      let response;
      let result;

      if (selectedOption === "approved") {
        approvedFiles.forEach((file) => formData.append("attachments", file));

        response = await fetch(`${API_URL}/api/approve_vendor_pr_email`, {
          method: "PUT",
          headers: {
            Authorization: authKey,
          },
          body: formData,
        });

        result = await response.json();
        if (result.status) {
          setSnackbarMessage(result.message);
          setSeverity("success");
          setSnackbarOpen(true);
          setShowPopup(false);
          setIsDeletePopup(false);
          await fetchPRRequestHistory();
          // 🧹 Reset states
          setApprovedFiles([]);
          setSelectedOption(null);
          setRemarks("");
          setRemarkFiles([]);
        } else {
          setSnackbarMessage(result.message);
          setSnackbarOpen(true);
        }
      } else if (selectedOption === "remarks") {
        formData.append("remark", remarks);
        remarkFiles.forEach((file) => formData.append("attachments", file));

        response = await fetch(`${API_URL}/api/add_vendor_pr_email_remark`, {
          method: "POST",
          headers: {
            Authorization: authKey,
          },
          body: formData,
        });

        result = await response.json();
        if (result.status) {
          setSnackbarMessage(result.message);
          setSeverity("success");
          setSnackbarOpen(true);
          setShowPopup(false);
          setIsDeletePopup(false);
          await fetchPRRequestHistory();
          // 🧹 Reset states
          setApprovedFiles([]);
          setSelectedOption(null);
          setRemarks("");
          setRemarkFiles([]);
        } else {
          setSnackbarMessage(result.message);
          setSnackbarOpen(true);
        }
      }
    } catch (error) {
      console.error("Submission error:", error);
      setSnackbarMessage("Something went wrong!");
      setSnackbarOpen(true);
    }
  };

  const handleCancel = () => {
    setShowPopup(false);
    setApprovedFiles([]);
    setSelectedOption(null);
    setRemarks("");
    setRemarkFiles([]);
  };

  const handleFinalCancel = () => {
    setIsDeletePopup(false);
    setApprovedFiles([]);
    setSelectedOption(null);
    setRemarks("");
    setRemarkFiles([]);
  };
  return (
    <>
      <div className="data-form-content">
        <div className="data-form-bodys12">
          <div className="pr-form">
            <form className="form-detail">
              <div className="new-data-form">
                <div className="form-group-select">
                  <label htmlFor="department_name">
                    From Email<span className="text-danger">*</span>
                  </label>
                  <Select
                    id="department_name"
                    options={email}
                    value={selectedEmails}
                    onChange={handleEmail}
                    placeholder="Select email"
                    isSearchable
                  />
                </div>

                <div className="form-group-select">
                  <label htmlFor="department_name">
                    Select Template<span className="text-danger">*</span>
                  </label>
                  <Select
                    id="department_name"
                    options={emails} // emails should be in the format { label, value }
                    value={selectedEmail}
                    onChange={handleEmailChange}
                    placeholder="Select email template"
                    isSearchable
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="to_email">To Emails</label>
                  <div className="input-group">
                    <input
                      type="email"
                      id="to_email"
                      name="to_email"
                      value={emailData.to_email}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
                <div className="form-group">
                  <label htmlFor="cc_email">CC Email</label>
                  <div className="input-group">
                    <input
                      type="email"
                      id="cc_email"
                      name="cc_email"
                      value={emailData.cc_email}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
                <div className="form-group">
                  <label htmlFor="subject">Subject</label>
                  <div className="input-group">
                    <textarea
                      id="subject"
                      name="subject"
                      value={emailData.subject}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
                <div className="form-group">
                  <label htmlFor="body">Body</label>
                  <div className="input-group">
                    <textarea
                      id="body"
                      name="body"
                      value={emailData.body}
                      onChange={handleInputChange}
                      rows={8}
                    />
                  </div>
                </div>
                <div className="form-group">
                  <label htmlFor="attachement">
                    Attachment {/* <span className="text-danger">*</span> */}
                  </label>
                  <button
                    type="button"
                    className="challan-btn"
                    onClick={handleUploadButtonClick}
                    ref={buttonRef}
                  >
                    <FiUpload /> Upload File
                  </button>
                  <input
                    id="attachments"
                    type="file"
                    ref={fileInputRef}
                    style={{ display: "none" }}
                    onChange={handleFileInputChange}
                    multiple
                  />
                  {selectedFiles.length > 0 && (
                    <span
                      className="inquiry-file-btn"
                      onClick={handleIconClicks}
                      ref={buttonRef}
                    >
                      <MdAttachFile className="inquiry-file-icon" />{" "}
                      {`${selectedFiles.length}`}
                    </span>
                  )}
                  {isPopupOpens && (
                    <div className="attach-popup-amc4" ref={popupRef}>
                      <div className="attach-popup-contant">
                        <div className="attachment-header">
                          <div className="attachment-header-content">
                            Attachments
                          </div>
                          <button
                            className="fiile-close-btn"
                            onClick={handleCloseAttachments}
                          >
                            <IoCloseOutline className="file-close-icon" />
                          </button>
                        </div>
                        {selectedFiles.length > 0 && (
                          <div className="attach-scrroll-body">
                            {selectedFiles.map((file, index) => (
                              <div
                                className="attach-popup-contant-body"
                                key={index}
                              >
                                <div className="attach-file-container">
                                  <div className="attach-file-show">
                                    <div className="text-attachment">
                                      {file.name}
                                    </div>
                                    <div className="text-attachment-file">
                                      File Size:(
                                      {(file.size / 1024).toFixed(2)} KB)
                                    </div>
                                  </div>
                                  <div
                                    className="file-delete-btn"
                                    onClick={() => handleDeleteFile(index)}
                                  >
                                    <span>
                                      {" "}
                                      <MdDeleteOutline className="file-delete-icon" />
                                    </span>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </form>
            <div className="history-button">
              <div className="button-group">
                <button
                  className="data-form-save-button"
                  type="button"
                  onClick={handleSaveClick}
                  disabled={isLoading}
                >
                  {isLoading ? "Sending Email..." : "Send Email"}
                </button>
                <button
                  className="data-form-cancel-button"
                  // onClick={() => navigate("/vendor")}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
          {/* Quotation History Table */}
          <div className="quotation-history">
            <h2>PR Request History</h2>
            <div className="data-list-scroll-body12">
              <div className="data-list-tables">
                {loading ? (
                  <div className="loader-container">
                    {/* <div className="loader"></div>
                      <div>Loading...</div> */}
                  </div>
                ) : prRequestHistory.length > 0 ? (
                  <table className="tables multilevel-data">
                    <thead>
                      <tr>
                        <th>SR. NO.</th>
                        {/* <th>VENDOR NAME</th> */}
                        <th>EMAIL</th>
                        <th>CC EMAIL</th>
                        <th>SUBJECT</th>
                        <th>BODY</th>
                        <th>STATUS</th>
                        <th>REMARKS</th>
                        <th>APPROVED/REMARK ATTACHMENTS</th>
                        <th>ATTACHMENTS</th>
                        <th>ACTION</th>
                      </tr>
                    </thead>

                    <tbody>
                      {prRequestHistory.length > 0 &&
                        prRequestHistory.map((prRequest, index) => {
                          const emailAttachments =
                            prRequest.attachments?.filter(
                              (att) => att.attachments_type === "email"
                            );
                          const remarkAttachments =
                            prRequest.attachments?.filter(
                              (att) => att.attachments_type === "remark"
                            );
                          return (
                            <tr
                              key={prRequest.pr_request_id || index}
                              className="hoverable-row"
                            >
                              {" "}
                              {/* Use a unique ID if available */}
                              <td>{index + 1}</td>
                              {/* <td>{formatDate(prRequest.date)}</td> */}
                              {/* <td>{prRequest.vendor_name || "NA"}</td> */}
                              {/* <td>{prRequest.to_email}</td> */}
                              <td>
                                {prRequest.to_email
                                  .split(",")
                                  .map((email, index) => (
                                    <span key={index}>
                                      {email}
                                      <br />
                                    </span>
                                  ))}
                              </td>
                              {/* <td>
                                {prRequest.cc_email
                                  .split(",")
                                  .map((email, index) => (
                                    <span key={index}>
                                      {email}
                                      <br />
                                    </span>
                                  ))}
                              </td> */}
                              <td>{prRequest.cc_email || "NA"}</td>
                              <td>{prRequest.subject || "NA"}</td>
                              <td>{prRequest.body || "NA"}</td>
                              <td>{prRequest.status || "NA"}</td>
                              <td>{prRequest.remark || "NA"}</td>
                              <td className="center-alignment">
                                <span
                                  className="inquiry-file-btns"
                                  onClick={() => handleRemarkClick(index)}
                                >
                                  <MdAttachFile className="inquiry-file-icon" />
                                </span>
                                {openRemarkPopupIndex === index && (
                                  <div
                                    className="inquiry-attach-popup"
                                    ref={popupRef}
                                  >
                                    <div className="attach-popup-contant">
                                      <div className="attachment-header">
                                        <div className="attachment-header-content">
                                          Remark Attachments
                                        </div>
                                        <button
                                          className="fiile-close-btn"
                                          onClick={handleCloseRemark}
                                        >
                                          <IoCloseOutline className="file-close-icon" />
                                        </button>
                                      </div>
                                      <div
                                        className="attach-popup-contant-body"
                                        key={index}
                                      >
                                        {remarkAttachments?.length > 0 ? (
                                          remarkAttachments.map(
                                            (attachment, attachmentIndex) => (
                                              <div
                                                className="inquiry-attach-file-container"
                                                key={attachmentIndex}
                                              >
                                                <div className="text-attachment">
                                                  {attachment.filename}
                                                </div>
                                                <div className="text-attachment-file">
                                                  File Size:{" "}
                                                  {attachment.file_size || "NA"}{" "}
                                                  KB
                                                </div>
                                                <div className="file-footer">
                                                  <a
                                                    href={`${API_URL}/api/customer/pr/download_email_attachment/${attachment.file_id}`}
                                                    download
                                                    className="file-download-attachment file-txt"
                                                  >
                                                    Download
                                                  </a>
                                                  <a
                                                    href={`${API_URL}/api/customer/pr/view_email_attachment/${attachment.file_id}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="file-download-attachment file-txt"
                                                  >
                                                    View
                                                  </a>
                                                </div>
                                              </div>
                                            )
                                          )
                                        ) : (
                                          <div className="no-attachments">
                                            No attachments found
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </td>
                              <td className="center-alignment">
                                <span
                                  className="inquiry-file-btns"
                                  onClick={() => handleEmailClick(index)}
                                >
                                  <MdAttachFile className="inquiry-file-icon" />
                                </span>
                                {openEmailPopupIndex === index && (
                                  <div
                                    className="inquiry-attach-popup"
                                    ref={popupRef}
                                  >
                                    <div className="attach-popup-contant">
                                      <div className="attachment-header">
                                        <div className="attachment-header-content">
                                          Email Attachments
                                        </div>
                                        <button
                                          className="fiile-close-btn"
                                          onClick={handleCloseEmail}
                                        >
                                          <IoCloseOutline className="file-close-icon" />
                                        </button>
                                      </div>
                                      <div
                                        className="attach-popup-contant-body"
                                        key={index}
                                      >
                                        {emailAttachments?.length > 0 ? (
                                          emailAttachments.map(
                                            (attachment, attachmentIndex) => (
                                              <div
                                                className="inquiry-attach-file-container"
                                                key={attachmentIndex}
                                              >
                                                <div className="text-attachment">
                                                  {attachment.filename}
                                                </div>
                                                <div className="text-attachment-file">
                                                  File Size:{" "}
                                                  {attachment.file_size || "NA"}{" "}
                                                  KB
                                                </div>
                                                <div className="file-footer">
                                                  <a
                                                    href={`${API_URL}/api/customer/pr/download_email_attachment/${attachment.file_id}`}
                                                    download
                                                    className="file-download-attachment file-txt"
                                                  >
                                                    Download
                                                  </a>
                                                  <a
                                                    href={`${API_URL}/api/customer/pr/view_email_attachment/${attachment.file_id}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="file-download-attachment file-txt"
                                                  >
                                                    View
                                                  </a>
                                                </div>
                                              </div>
                                            )
                                          )
                                        ) : (
                                          <div className="no-attachments">
                                            No attachments found
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </td>
                              {/* <td>
  <button 
    className="button-bg" 
    onClick={() => handleAction(prRequest.id)} // Pass prRequest.id when the button is clicked
  >
    Action
  </button>
</td> */}
                              <td>
                                {prRequest.customer_approved === 1 ? (
                                  // Approved case
                                  <button className="button-bg" disabled>
                                    Close Approved
                                  </button>
                                ) : prRequest.remark ? (
                                  // Remark exists & not approved case
                                  <button className="button-bg" disabled>
                                    Close Remark
                                  </button>
                                ) : (
                                  // Default case - Action button
                                  <button
                                    className="button-bg"
                                    onClick={() => handleAction(prRequest.id)}
                                  >
                                    Action
                                  </button>
                                )}
                              </td>
                              {showPopup && (
                                <div
                                  className="reminder-popup-model"
                                  ref={popupRef}
                                >
                                  <div className="reminder-popup-content approval-popup">
                                    <div className="reminder-popup-model-header">
                                      <div className="reminder-popup-model-content-header">
                                        <div className="reminder-popup-model-content-header-left-part">
                                          Approval or Return Remarks from
                                          Customer
                                        </div>
                                        <div className="reminder-popup-model-content-header-right-part"></div>
                                      </div>
                                      <div className="popup-new-form">
                                        <form className="popup-form-detail approval-popup-detail">
                                          <div className="new-data-form">
                                            <div className="form-group-select email-field msmme">
                                              <label htmlFor="fileType">
                                                Choose any one:
                                                <span className="text-danger">
                                                  *
                                                </span>
                                              </label>
                                              <div className="checkbox-input">
                                                <input
                                                  type="radio"
                                                  name="action"
                                                  value="approved"
                                                  checked={
                                                    selectedOption ===
                                                    "approved"
                                                  }
                                                  onChange={() =>
                                                    setSelectedOption(
                                                      "approved"
                                                    )
                                                  }
                                                />
                                                <label>Approve</label>
                                              </div>
                                              <div className="checkbox-input">
                                                <input
                                                  type="radio"
                                                  name="action"
                                                  value="remarks"
                                                  checked={
                                                    selectedOption === "remarks"
                                                  }
                                                  onChange={() =>
                                                    setSelectedOption("remarks")
                                                  }
                                                />
                                                <label>Remarks</label>
                                              </div>
                                            </div>

                                            {selectedOption === "approved" && (
                                              <div className="form-group">
                                                <label>
                                                  Approval Attachments
                                                </label>
                                                <button
                                                  type="button"
                                                  className="challan-btn"
                                                  onClick={
                                                    handleApprovedUploadClick
                                                  }
                                                  ref={approvedBtnRef}
                                                >
                                                  <FiUpload /> Upload File
                                                </button>
                                                <input
                                                  type="file"
                                                  ref={approvedFileRef}
                                                  style={{ display: "none" }}
                                                  onChange={
                                                    handleApprovedFileChange
                                                  }
                                                  multiple
                                                />
                                                {approvedFiles.length > 0 && (
                                                  <span
                                                    className="inquiry-file-btn"
                                                    onClick={
                                                      handleApprovedPopupIconClick
                                                    }
                                                    ref={approvedBtnRef}
                                                  >
                                                    <MdAttachFile className="inquiry-file-icon" />{" "}
                                                    {approvedFiles.length}
                                                  </span>
                                                )}
                                                {approvedPopupOpen && (
                                                  <div
                                                    className="attach-popup-amc4"
                                                    ref={approvedPopupRef}
                                                  >
                                                    <div className="attach-popup-contant">
                                                      <div className="attachment-header">
                                                        <div className="attachment-header-content">
                                                          Attachments
                                                        </div>
                                                        <button
                                                          className="fiile-close-btn"
                                                          onClick={
                                                            handleApprovedPopupClose
                                                          }
                                                        >
                                                          <IoCloseOutline className="file-close-icon" />
                                                        </button>
                                                      </div>
                                                      <div className="attach-scrroll-body">
                                                        {approvedFiles.map(
                                                          (file, index) => (
                                                            <div
                                                              className="attach-popup-contant-body"
                                                              key={index}
                                                            >
                                                              <div className="attach-file-container">
                                                                <div className="attach-file-show">
                                                                  <div className="text-attachment">
                                                                    {file.name}
                                                                  </div>
                                                                  <div className="text-attachment-file">
                                                                    File Size:{" "}
                                                                    {(
                                                                      file.size /
                                                                      1024
                                                                    ).toFixed(
                                                                      2
                                                                    )}{" "}
                                                                    KB
                                                                  </div>
                                                                </div>
                                                                <div
                                                                  className="file-delete-btn"
                                                                  onClick={() =>
                                                                    handleApprovedDelete(
                                                                      index
                                                                    )
                                                                  }
                                                                >
                                                                  <MdDeleteOutline className="file-delete-icon" />
                                                                </div>
                                                              </div>
                                                            </div>
                                                          )
                                                        )}
                                                      </div>
                                                    </div>
                                                  </div>
                                                )}
                                              </div>
                                            )}

                                            {selectedOption === "remarks" && (
                                              <>
                                                <div className="form-group email-filed">
                                                  <label>
                                                    Return Remarks from
                                                    Customer:
                                                    <span className="text-danger">
                                                      *
                                                    </span>
                                                  </label>
                                                  <div className="input-group">
                                                    {/* <input
                                                      type="text"
                                                      value={remarks}
                                                      onChange={(e) =>
                                                        setRemarks(
                                                          e.target.value
                                                        )
                                                      }
                                                    /> */}
                                                    <textarea
                                                      value={remarks}
                                                      onChange={(e) =>
                                                        setRemarks(
                                                          e.target.value
                                                        )
                                                      }
                                                      rows={4} // You can adjust this as needed
                                                      placeholder="Enter remarks from the customer"
                                                    />
                                                  </div>
                                                </div>

                                                <div className="form-group">
                                                  <label>
                                                    Remark Attachments
                                                  </label>
                                                  <button
                                                    type="button"
                                                    className="challan-btn"
                                                    onClick={
                                                      handleRemarkUploadClick
                                                    }
                                                    ref={remarkBtnRef}
                                                  >
                                                    <FiUpload /> Upload File
                                                  </button>
                                                  <input
                                                    type="file"
                                                    ref={remarkFileRef}
                                                    style={{ display: "none" }}
                                                    onChange={
                                                      handleRemarkFileChange
                                                    }
                                                    multiple
                                                  />
                                                  {remarkFiles.length > 0 && (
                                                    <span
                                                      className="inquiry-file-btn"
                                                      onClick={
                                                        handleRemarkPopupIconClick
                                                      }
                                                      ref={remarkBtnRef}
                                                    >
                                                      <MdAttachFile className="inquiry-file-icon" />{" "}
                                                      {remarkFiles.length}
                                                    </span>
                                                  )}
                                                  {remarkPopupOpen && (
                                                    <div
                                                      className="attach-popup-amc4"
                                                      ref={remarkPopupRef}
                                                    >
                                                      <div className="attach-popup-contant">
                                                        <div className="attachment-header">
                                                          <div className="attachment-header-content">
                                                            Attachments
                                                          </div>
                                                          <button
                                                            className="fiile-close-btn"
                                                            onClick={
                                                              handleRemarkPopupClose
                                                            }
                                                          >
                                                            <IoCloseOutline className="file-close-icon" />
                                                          </button>
                                                        </div>
                                                        <div className="attach-scrroll-body">
                                                          {remarkFiles.map(
                                                            (file, index) => (
                                                              <div
                                                                className="attach-popup-contant-body"
                                                                key={index}
                                                              >
                                                                <div className="attach-file-container">
                                                                  <div className="attach-file-show">
                                                                    <div className="text-attachment">
                                                                      {
                                                                        file.name
                                                                      }
                                                                    </div>
                                                                    <div className="text-attachment-file">
                                                                      File Size:{" "}
                                                                      {(
                                                                        file.size /
                                                                        1024
                                                                      ).toFixed(
                                                                        2
                                                                      )}{" "}
                                                                      KB
                                                                    </div>
                                                                  </div>
                                                                  <div
                                                                    className="file-delete-btn"
                                                                    onClick={() =>
                                                                      handleRemarkDelete(
                                                                        index
                                                                      )
                                                                    }
                                                                  >
                                                                    <MdDeleteOutline className="file-delete-icon" />
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            )
                                                          )}
                                                        </div>
                                                      </div>
                                                    </div>
                                                  )}
                                                </div>
                                              </>
                                            )}
                                          </div>
                                        </form>
                                      </div>
                                      <div className="footers">
                                        <div className="button-group-email">
                                          <div>
                                            <button
                                              className="person-user-save-button"
                                              type="button"
                                              onClick={handleSubmit}
                                              // disabled={isSending}
                                            >
                                              Submit
                                            </button>

                                            <button
                                              className="person-user-cancel-button"
                                              // onClick={() => setShowPopup(false)}
                                              onClick={handleCancel}
                                            >
                                              Cancel
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                              {isDeletePopup && (
                                <div className="confirm-delete-popup">
                                  <div className="confirm-delete-popup-content">
                                    <div className="confirm-model">
                                      <div className="confirm-model-content">
                                        <div className="confirm-model-content-body">
                                          <p>
                                            Are you sure you want to perform
                                            this action? Once done, it cannot be
                                            edited
                                          </p>
                                        </div>
                                        <div className="confirm-model-content-footer">
                                          <button
                                            className="confirm-delete-button"
                                            onClick={handleFinalSubmit}
                                          >
                                            Yes
                                          </button>
                                          <button
                                            className="confirm-cancel-button"
                                            onClick={handleFinalCancel}
                                          >
                                            No
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                ) : (
                  <div className="no-users-container">
                    <div className="no-users-message">
                      No pr request history available
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MuiAlert onClose={handleSnackbarClose} severity={severity}>
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </>
  );
}

export default ConfirmPRRequest;
